
import { ArrowDown } from "lucide-react";
import { WalletButton } from "@/wallet";

interface HeroProps {
  onConnectWallet: () => void;
}

const Hero = ({
  onConnectWallet
}: HeroProps) => {
  const scrollToNextSection = () => {
    const nextSection = document.getElementById("lore");
    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  
  return (
    <div className="relative w-full full-width-container">
      {/* Container with responsive height approach */}
      <div className="relative min-h-[100vh]">
        <img 
          src="/lovable-uploads/1febe35f-abd8-480e-bfc6-6cd24cc3bc42.png" 
          alt="Hero background" 
          className="w-full h-full object-cover absolute inset-0"
        />
        
        {/* Gradient overlay for better text visibility */}
        <div className="absolute inset-0 bg-black/20"></div>
        
        {/* Content positioned with flex to ensure visibility */}
        <div className="relative min-h-[100vh] flex flex-col items-center justify-center px-4 py-8 text-center">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 text-white tracking-tight drop-shadow-lg">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-orange-400 to-orange-600">
              Don't Get Washed Up.
            </span>
            <br />
            <span className="text-shadow-lg">Seas the Day with $POP</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-10 max-w-2xl text-orange-200 drop-shadow-lg animate-pulse-slow glow-text">
            Just another cute otter… with a Glock 19 & one hell of a plan.
          </p>
          
          <div className="mb-16">
            <WalletButton 
              size="lg" 
              className="py-6 px-8 text-lg"
            />
          </div>
          
          {/* Scroll indicator with adjusted positioning */}
          <div 
            onClick={scrollToNextSection} 
            className="absolute bottom-20 md:bottom-12 left-0 right-0 flex justify-center cursor-pointer animate-bounce"
          >
            <ArrowDown size={32} className="text-white/80" />
          </div>
        </div>

        {/* Animated water ripple effect at bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-blue-900/30 to-transparent overflow-hidden">
          <div className="ripple-1"></div>
          <div className="ripple-2"></div>
          <div className="ripple-3"></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
